import {
  FETCH_MISSIONS_REQUEST,
  FETCH_MISSIONS_SUCCESS,
  FETCH_MISSIONS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  list: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_MISSIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_MISSIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_MISSIONS_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      }

    default:
      return state
  }
}
